import { WithdrawalsReceiveSetLimitsReducer } from './types';

export const withdrawalsReceiveSetLimitsReducer: WithdrawalsReceiveSetLimitsReducer =
  (state, action) => {
    const { items } = action.payload;

    const { withdrawalsLimits } = state;

    if (!withdrawalsLimits) {
      return state;
    }

    return {
      ...state,
      withdrawalsLimits: {
        ...withdrawalsLimits,
        items,
      },
      withdrawalsLimitsProcessedItems: items,
    };
  };
